export function criarFormulario() {
	return {
		descricao: "",
		chaveIntegracao: "",
		validade: -1
	};
}
